import {AsyncPipe, NgIf} from "@angular/common";
import {HttpClient, HttpParams} from "@angular/common/http";
import {ChangeDetectorRef, Component, EventEmitter, Inject, OnInit, Output, ViewChild} from '@angular/core';
import {FlexLayoutModule} from "@angular/flex-layout";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {MatButtonModule} from "@angular/material/button";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {MatError} from "@angular/material/form-field";
import {MatIconModule} from "@angular/material/icon";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {RouterLink} from "@angular/router";
import {LoadingComponent} from "@ui-kit/framework/common/loading.component";
import {CurrentContextService} from "@ui-kit/framework/security/service/current-context.service";
import {LoadingService} from "@ui-kit/framework/util/service/loading.service";
import {SnackbarService} from "@ui-kit/framework/util/service/snackbar.service";
import {NgOtpInputModule} from "ng-otp-input";

@Component({
  selector: 'app-otp-dialog',
  standalone: true,
  imports: [
    MatIconModule,
    NgOtpInputModule,
    MatProgressSpinnerModule,
    MatError,
    RouterLink,
    FlexLayoutModule,
    MatButtonModule,
    NgIf,
    AsyncPipe
  ],
  templateUrl: './otp-dialog.component.html'
})
export class OtpDialogComponent extends LoadingComponent implements OnInit {
  @ViewChild('ngOtpInput') ngOtpInputRef: any;
  @Output() dataSubmitted = new EventEmitter<any>();

  message: string = '';
  requestEndpoint: string = '';
  confirmEndpoint: string = '';
  confirmBody: any = {};
  params: {name: string, val: string}[] = [];

  otpForm: FormGroup;
  errMessage: string | null = '';
  email: string = '';
  len = 0;

  constructor(
    public dialogRef: MatDialogRef<OtpDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private context: CurrentContextService<any>,
    private httpClient: HttpClient,
    private snackBar: SnackbarService,
    loader: LoadingService,
    cdr: ChangeDetectorRef
  ) {
    super(loader, cdr);
    this.message = this.data.message ?? 'Please verify your email address';
    this.requestEndpoint = this.data.requestEndpoint || '';
    this.confirmEndpoint = this.data.confirmEndpoint || '';
    this.confirmBody = this.data.confirmBody || {};
    this.params = this.data.params || [];

    this.otpForm = this.resetForm();
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.getUserEmail();
    this.requestOtpFromEndpoint();
  }

  requestOtpFromEndpoint() {
    this.httpClient.post(this.requestEndpoint, this.otpForm.value)
      .subscribe({
        next: (value) => {
          this.snackBar.openSnackBar(`OTP successfully sent to ${this.email}.`)
        },
        error: err => {
          this.handleError(err);
        }
      });
  }

  confirmOtpFromEndpoint() {
    let requestParams = new HttpParams()
      .set('otp', this.otpForm.get('pin')!.value);
    if (this.params) {
      this.params.filter(f => f.val !== null).forEach(ea => {
        requestParams = requestParams.append(ea.name, ea.val)
      });
    }

    this.httpClient.post(this.confirmEndpoint, this.confirmBody, {params: requestParams})
      .subscribe({
        next: (value) => {
          this.dataSubmitted.emit(value);
        },
        error: err => {
          this.handleError(err);
        }
      });
  }

  onOtpChange(event: any): void {
    this.otpForm.get('pin')!.setValue(event);
    this.getPinAmount();
    this.len = this.otpForm.value.pin.toString().length;
  }

  public getPinAmount(): boolean {
    return this.otpForm.value.pin ? this.otpForm.value.pin.toString().length < 4 : true;
  }

  close() {
    this.dialogRef.close();
  }

  public onResendOTP(): void {
    this.errMessage = null;
    this.requestOtpFromEndpoint();
  }

  private getUserEmail(): void {
    this.email = this.context.currentUser!.email;
  }

  private resetForm(): FormGroup {
    return this.fb.group({
      pin: [null, Validators.required],
    });
  }

  private handleError(err: any): void {
    switch (err.status) {
      case 400:
        if ('ValidationException' === err.headers.get('error_code')) {
          this.errMessage = '' + err.headers.get('error_message');
        }
        this.snackBar.openSnackBar('unexpected error: ' + this.errMessage);
        break;
      default:
        this.snackBar.openSnackBar('unexpected error');
    }
  }
}
